import {
  DocumentCategory,
  Document,
  DocumentComment,
  DocumentRequestChecklistItem
} from 'share/domain/document'

import {
  DocumentProcessing,
  getEmptyDocumentProcessing
} from 'reducers/document/documentProcessingSlice'

export function saveToSessionStorageSelectedDocumentId(
  payload: number | null
): void {
  const sessionStor = window.sessionStorage
  if (payload) {
    sessionStor.setItem('doc-sel-docId', payload.toString())
  } else {
    sessionStor.removeItem('doc-sel-docId')
  }
}

export function saveToSessionStorageSelectedDocument(
  payload: Document | null
): void {
  const sessionStor = window.sessionStorage
  if (payload) {
    if (payload.id) {
      sessionStor.setItem('doc-sel-doc-id', payload.id.toString())
    } else {
      sessionStor.removeItem('doc-sel-doc-id')
    }

    if (payload.name) {
      sessionStor.setItem('doc-sel-doc-name', payload.name)
    } else {
      sessionStor.removeItem('doc-sel-doc-name')
    }

    if (payload.status) {
      sessionStor.setItem('doc-sel-doc-status', payload.status)
    } else {
      sessionStor.removeItem('doc-sel-doc-status')
    }
    if (payload.uploaded) {
      sessionStor.setItem('doc-sel-doc-uploaded', payload.uploaded)
    } else {
      sessionStor.removeItem('doc-sel-doc-uploaded')
    }

    if (payload.comments && payload.comments.length > 0) {
      const comm1 = payload.comments[0]
      sessionStor.setItem('doc-sel-doc-com1-id', comm1.id.toString())
      if (comm1.attorneyName) {
        sessionStor.setItem('doc-sel-doc-com1-attorneyName', comm1.attorneyName)
      } else {
        sessionStor.removeItem('doc-sel-doc-com1-attorneyName')
      }
      if (comm1.attorneyAvatarUrl) {
        sessionStor.removeItem('doc-sel-doc-com1-avatar')
        sessionStor.setItem('doc-sel-doc-com1-avatar', comm1.attorneyAvatarUrl)
      } else {
        sessionStor.removeItem('doc-sel-doc-com1-avatar')
      }
      sessionStor.setItem('doc-sel-doc-com1-comment', comm1.comment)
      sessionStor.setItem('doc-sel-doc-com1-created', comm1.created)
    }
  } else {
    sessionStor.removeItem('doc-sel-doc-id')
    sessionStor.removeItem('doc-sel-doc-name')
    sessionStor.removeItem('doc-sel-doc-status')
    sessionStor.removeItem('doc-sel-doc-uploaded')
    sessionStor.removeItem('doc-sel-doc-com1-id')
    sessionStor.removeItem('doc-sel-doc-com1-attorneyName')
    sessionStor.removeItem('doc-sel-doc-com1-avatar')
    sessionStor.removeItem('doc-sel-doc-com1-comment')
    sessionStor.removeItem('doc-sel-doc-com1-created')
  }
}

export function saveToSessionStorageSelectedDocumentCategoryId(
  payload: number | null
): void {
  const sessionStor = window.sessionStorage
  if (payload) {
    sessionStor.setItem('doc-sel-docCatId', payload.toString())
  } else {
    sessionStor.removeItem('doc-sel-docCatId')
  }
}

export function saveToSessionStorageDocumentCategory(
  payload: DocumentCategory | null
): void {
  const sessionStor = window.sessionStorage
  if (payload) {
    sessionStor.setItem('doc-sel-cat-id', payload.id.toString())
    sessionStor.setItem('doc-sel-cat-name', payload.name)
    sessionStor.setItem('doc-sel-cat-descr', payload.description)
    sessionStor.setItem('doc-sel-cat-subcatlst', payload.subcategoryList)
    sessionStor.setItem('doc-sel-cat-status', payload.status)
  } else {
    sessionStor.removeItem('doc-sel-cat-id')
    sessionStor.removeItem('doc-sel-cat-name')
    sessionStor.removeItem('doc-sel-cat-descr')
    sessionStor.removeItem('doc-sel-cat-subcatlst')
    sessionStor.removeItem('doc-sel-cat-status')
  }
}

export function saveToSessionStorageSelectedDocumentChecklistItemId(
  payload: number | null
): void {
  const sessionStor = window.sessionStorage
  if (payload) {
    sessionStor.setItem('doc-sel-check-list-item-id', payload.toString())
  } else {
    sessionStor.removeItem('doc-sel-check-list-item-id')
  }
}

export function saveToSessionStorageDocumentChecklist(
  payload: DocumentRequestChecklistItem | null
): void {
  const sessionStor = window.sessionStorage
  if (payload) {
    sessionStor.setItem('doc-sel-check-list-item-id', payload.id.toString())
    if (payload.name) {
      sessionStor.setItem('doc-sel-check-list-item-name', payload.name)
    }
    if (payload.status) {
      sessionStor.setItem('doc-sel-check-list-item-status', payload.status)
    }

    sessionStor.setItem(
      'doc-sel-check-list-item-document-count',
      payload.documentCount.toString()
    )
    if (payload.comment) {
      sessionStor.setItem('doc-sel-check-list-item-comment', payload.comment)
    }
    if (payload.hasWarnings) {
      sessionStor.setItem(
        'doc-sel-check-list-item-has-warnings',
        payload.hasWarnings.toString()
      )
    }
    if (payload.durationDescription) {
      sessionStor.setItem(
        'doc-sel-check-list-item-dur-descr',
        payload.hasWarnings.toString()
      )
    }
    sessionStor.setItem(
      'doc-sel-check-list-item-type',
      payload.documentItemTypeId.toString()
    )
  } else {
    sessionStor.removeItem('doc-sel-check-list-item-id')
    sessionStor.removeItem('doc-sel-check-list-item-name')
    sessionStor.removeItem('doc-sel-check-list-item-status')
    sessionStor.removeItem('doc-sel-check-list-item-document-count')
    sessionStor.removeItem('doc-sel-check-list-item-comment')
    sessionStor.removeItem('doc-sel-check-list-item-has-warnings')
    sessionStor.removeItem('doc-sel-check-list-item-dur-descr')
    sessionStor.removeItem('doc-sel-check-list-item-type')
    sessionStor.removeItem('doc-sel-check-list-item-type')
  }
}

export function saveToSessionStorageDocumentOperation(
  payload: 'Submit' | 'Review' | null
): void {
  const sessionStor = window.sessionStorage
  if (payload) {
    sessionStor.setItem('doc-operation', payload)
  } else {
    sessionStor.removeItem('doc-operation')
  }
}

export function saveToSessionStorageDocumentProcessing(
  payload: DocumentProcessing
): void {
  saveToSessionStorageSelectedDocumentId(payload.selectedDocumentId)
  saveToSessionStorageSelectedDocument(payload.selectedDocument)
  saveToSessionStorageSelectedDocumentCategoryId(
    payload.selectedDocumentCategoryId
  )
  saveToSessionStorageDocumentCategory(payload.selectedDocumentCategory)
  saveToSessionStorageDocumentOperation(payload.documentOperation)
}
export function saveActiveTabToSessionStorage(
  payload: 'submit' | 'review'
): void {
  const sessionStor = window.sessionStorage
  sessionStor.setItem('adocumentProcessing-activetab', payload)
}

export function saveDefaultActiveAccordionSessionStorage(
  payload: number | 0
): void {
  const sessionStor = window.sessionStorage
  if (payload) {
    sessionStor.setItem('doc-default-accordion', payload.toString())
  } else {
    sessionStor.removeItem('doc-default-accordion')
  }
}

export function loadDocumentProcessingFromSessionStorage(): DocumentProcessing {
  const sessionStor = window.sessionStorage
  const documentProcessing = getEmptyDocumentProcessing()

  const docOperation = sessionStor.getItem('doc-operation')
  if (
    docOperation &&
    (docOperation === 'Submit' || docOperation === 'Review')
  ) {
    documentProcessing.documentOperation = docOperation
  }

  const docCategoryId = sessionStor.getItem('doc-sel-docCatId')
  if (docCategoryId) {
    documentProcessing.selectedDocumentCategoryId = parseInt(docCategoryId)
  }

  const selDocCategoryId = sessionStor.getItem('doc-sel-docCatId')
  const selDocCategoryName = sessionStor.getItem('doc-sel-cat-name')
  const selDocCategoryDescr = sessionStor.getItem('doc-sel-cat-descr')
  const selDocCategorySubCatLst = sessionStor.getItem('doc-sel-cat-subcatlst')
  const selDocCategoryStatus = sessionStor.getItem('doc-sel-cat-status')

  if (selDocCategoryId && selDocCategoryName && selDocCategoryStatus) {
    const selectedDocumentCategory = {
      id: parseInt(selDocCategoryId),
      name: selDocCategoryName,
      description: '',
      subcategoryList: '',
      status: selDocCategoryStatus
    }
    if (selDocCategoryDescr) {
      selectedDocumentCategory.description = selDocCategoryDescr
    }
    if (selDocCategorySubCatLst) {
      selectedDocumentCategory.subcategoryList = selDocCategorySubCatLst
    }
    documentProcessing.selectedDocumentCategory = selectedDocumentCategory
  }

  const docSelectedChecklistItemId = sessionStor.getItem(
    'doc-sel-check-list-item-id'
  )
  if (docSelectedChecklistItemId) {
    documentProcessing.selectedDocumentChecklistItemId = parseInt(
      docSelectedChecklistItemId
    )
  }

  const selChecklistItemName = sessionStor.getItem(
    'doc-sel-check-list-item-name'
  )
  const selChecklistItemStatus = sessionStor.getItem(
    'doc-sel-check-list-item-status'
  )

  const selChecklistItemDocumentCount = sessionStor.getItem(
    'doc-sel-check-list-item-document-count'
  )
  const selChecklistItemDocumentComment = sessionStor.getItem(
    'doc-sel-check-list-item-comment'
  )
  let selChecklistItemHasWarnings = sessionStor.getItem(
    'doc-sel-check-list-item-has-warnings'
  )

  if (!selChecklistItemHasWarnings) {
    selChecklistItemHasWarnings = 'false'
  }

  const tempSelChecklistItemHasWarnings = selChecklistItemHasWarnings === 'true'
  const selChecklistItemDurationDescription = sessionStor.getItem(
    'doc-sel-check-list-item-dur-descr'
  )

  const selChecklistItemDocumentItemTypeId = sessionStor.getItem(
    'doc-sel-check-list-item-type'
  )

  let tempSelChecklistItemDocumentItemTypeId = 0
  if (selChecklistItemDocumentItemTypeId) {
    tempSelChecklistItemDocumentItemTypeId = parseInt(
      selChecklistItemDocumentItemTypeId
    )
  }

  if (
    docSelectedChecklistItemId &&
    selChecklistItemName &&
    selChecklistItemStatus &&
    selChecklistItemDocumentCount
  ) {
    const selectedDocumentChecklistItem = {
      id: parseInt(docSelectedChecklistItemId),
      name: selChecklistItemName,
      status: selChecklistItemStatus,
      documentCount: parseInt(selChecklistItemDocumentCount),
      comment: selChecklistItemDocumentComment,
      hasWarnings: tempSelChecklistItemHasWarnings,
      durationDescription: selChecklistItemDurationDescription,
      documentItemTypeId: tempSelChecklistItemDocumentItemTypeId
    }
    documentProcessing.selectedDocumentChecklistItem =
      selectedDocumentChecklistItem
  }

  const selDocSubCategoryId = sessionStor.getItem('doc-sel-subcat-id')
  const selDocSubCategoryName = sessionStor.getItem('doc-sel-subcat-name')
  const selDocSubCategoryDescr = sessionStor.getItem('doc-sel-subcat-descr')
  const selDocSubCategorySubCatLst = sessionStor.getItem(
    'doc-sel-subcat-subcatlst'
  )
  const selDocSubCategoryStatus = sessionStor.getItem('doc-sel-subcat-status')

  if (selDocSubCategoryId && selDocSubCategoryName && selDocSubCategoryStatus) {
    const selectedDocumentSubCategory = {
      id: parseInt(selDocSubCategoryId),
      name: selDocSubCategoryName,
      description: '',
      subcategoryList: '',
      status: selDocSubCategoryStatus
    }
    if (selDocSubCategoryDescr) {
      selectedDocumentSubCategory.description = selDocSubCategoryDescr
    }
    if (selDocSubCategorySubCatLst) {
      selectedDocumentSubCategory.subcategoryList = selDocSubCategorySubCatLst
    }
  }

  const docSelId = sessionStor.getItem('doc-sel-docId')
  if (docSelId) {
    documentProcessing.selectedDocumentId = parseInt(docSelId)
  }

  const docId = sessionStor.getItem('doc-sel-doc-id')
  const docName = sessionStor.getItem('doc-sel-doc-name')
  const docStatus = sessionStor.getItem('doc-sel-doc-status')
  const docUploaded = sessionStor.getItem('doc-sel-doc-uploaded')

  const commentList: DocumentComment[] = []
  if (docId && docName && docStatus && docUploaded) {
    const doc = {
      id: parseInt(docId),
      name: docName,
      status: docStatus,
      uploaded: docUploaded,
      comments: commentList
    }

    const commId = sessionStor.getItem('doc-sel-doc-com1-id')
    const commAttorneyName = sessionStor.getItem(
      'doc-sel-doc-com1-attorneyName'
    )
    const commattorneyAvatarUrl = sessionStor.getItem('doc-sel-doc-com1-avatar')
    const commComment = sessionStor.getItem('doc-sel-doc-com1-comment')
    const commCreated = sessionStor.getItem('doc-sel-doc-com1-created')

    if (commId && commComment && commCreated) {
      const singleComment = {
        id: parseInt(commId),
        attorneyName: '',
        attorneyAvatarUrl: '',
        comment: commComment,
        created: commCreated
      }
      if (commAttorneyName) {
        singleComment.attorneyName = commAttorneyName
      }
      if (commattorneyAvatarUrl) {
        singleComment.attorneyAvatarUrl = commattorneyAvatarUrl
      }
      doc.comments.push(singleComment)
    }
    documentProcessing.selectedDocument = doc
  }

  return documentProcessing
}
